import React from 'react';
import MODAL, { MODAL_THEMES } from 'constants/modals';
import Modal from 'components/Modal';
import BundlesDetailsModalContent from './BundlesDetailsModalContent';

const BundlesDetailsModal = () => (
  <Modal modalKey={MODAL.BUNDLES_DETAILS_MODAL} theme={MODAL_THEMES.WHITE}>
    <BundlesDetailsModalContent />
  </Modal>
);

export default BundlesDetailsModal;
